import axios from "axios";

const API_BASE_URL = process.env.REACT_APP_API_URL || "http://localhost:5001";

export const createCpApi = (payload) =>
  axios.post(`${API_BASE_URL}/api/cp-database`, payload);

export const updateCpApi = (id, payload) =>
  axios.put(`${API_BASE_URL}/api/cp-database/${id}`, payload);

export const downloadCpWorkbook = async ({ addedBy } = {}) => {
  const res = await axios.get(`${API_BASE_URL}/api/cp-database/export`, {
    params: addedBy ? { addedBy } : {},
    responseType: "blob",
  });
  const disposition = res.headers["content-disposition"] || "";
  const match = disposition.match(/filename="?([^"]+)"?/);
  const url = window.URL.createObjectURL(res.data);
  const a = document.createElement("a");
  a.href = url;
  a.download = match ? match[1] : "cp-database.xlsx";
  document.body.appendChild(a);
  a.click();
  a.remove();
  window.URL.revokeObjectURL(url);
};
